@if (showHeader) {
  <div class="section-header reviews-header">
    <h2>Bewertungen</h2>
  </div>
}

@if (authService.currentUser$ | async) {
  @if (ownReviewStatus === 'pending') {
    <div class="pending-review-notice">
      <mat-icon>hourglass_top</mat-icon>
      <span>Deine Bewertung wird geprüft und kann derzeit nicht bearbeitet werden.</span>
    </div>
  }

  <form [formGroup]="reviewForm" (ngSubmit)="submitReview()" class="review-form">
    <h4>Deine Bewertung abgeben</h4>
    <div class="star-rating-input" [class.disabled]="ownReviewStatus === 'pending'">
      @for (star of [1, 2, 3, 4, 5]; track star) {
        <mat-icon (click)="setRating(star)" (mouseenter)="hoverRating = star" (mouseleave)="hoverRating = 0">
          {{ (hoverRating || reviewForm.get('rating')?.value) >= star ? 'star' : 'star_border' }}
        </mat-icon>
      }
    </div>
    <mat-form-field appearance="outline">
      <input type="text" aria-hidden="true" hidden autocomplete="off" />
      <mat-label>Dein Kommentar (optional)</mat-label>
      <textarea matInput formControlName="comment" rows="3"></textarea>
    </mat-form-field>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="(reviewForm.get('rating')?.value < 1 && ownReviewStatus === 'none') || ownReviewStatus === 'pending'"
    >
      {{ ownReviewStatus === 'approved' ? 'Änderung einreichen' : 'Bewertung absenden' }}
    </button>
  </form>
} @else {
  <p class="login-prompt">Du musst eingeloggt sein, um eine Bewertung abzugeben.</p>
}

<app-review-list
  [reviews]="(reviews$ | async) || []"
  [filteredReviews]="(otherReviews$ | async) || []"
  [restStop]="restStop"
></app-review-list>
